import { render } from "./Register-job-seeker.vue?vue&type=template&id=ed5f0c2c&ts=true"
import script from "./Register-job-seeker.vue?vue&type=script&lang=ts"
export * from "./Register-job-seeker.vue?vue&type=script&lang=ts"

import "./Register-job-seeker.vue?vue&type=style&index=0&id=ed5f0c2c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__